'use client';

import dynamic from 'next/dynamic';
import { useState, useEffect } from 'react';
import { Container, useTranslation } from '@weareconceptstudio/core';

//* Libs
import { getRelatedNews } from '@/libs/get-data';

//* Components
import MainSection from '../components/Main';
const Subscribe = dynamic(() => import('@/sections/Subscribe'));
const NewsSection = dynamic(() => import('@/sections/NewsSection'));
const GallerySection = dynamic(() => import('../components/GallerySection'));

//* Style
import NewsIndividualTemplateStyle from './style';

const NewsIndividualTemplate = ({ pageData }) => {
	const { selectedLang } = useTranslation();

	//! State
	const [data, setData] = useState([]);
	const id = pageData.id;

	useEffect(() => {
		const fetchData = async () => {
			const data = await getRelatedNews({ id, lang: selectedLang });

			setData(data);
		};

		fetchData();
	}, [id, selectedLang]);

	return (
		<NewsIndividualTemplateStyle>
			<Container>
				<MainSection {...pageData} />

				<GallerySection data={pageData.gallery} />

				<div className='subscribe-container'>
					<Subscribe />
				</div>

				<div className='news-wrapper'>
					<NewsSection
						data={data}
						showExplore={false}
						title={'related_news'}
					/>
				</div>
			</Container>
		</NewsIndividualTemplateStyle>
	);
};

export default NewsIndividualTemplate;
